import Layout from '@/layouts'
import {i18n} from "@/utils/i18n";

const categoryService = {
  path: '/categoryServices',
  component: Layout,
  name: 'categoryServices',
  redirect: '/categoryServices/index',
  children: [
    {
      path: '/categoryServices/index',
      component: () => import('@/views/categoryService/index'),
      name: 'categoryServices.index',
      meta: { title: i18n.t(`message.service_category`)}
    },
  ]
}

export default categoryService
